import { render } from "./App.vue?vue&type=template&id=7ee856e0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7ee856e0&lang=scss"

import exportComponent from "D:\\Projects\\my_personal_page_work_tv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__